import React from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';

import './SimpleTable.scss';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';

const SimpleTable = ({ columns, secondaryColumns, rows, columnWidths }) => {
  const renderWidths = () => {
    if (!isEmpty(columnWidths)) {
      return (
        <colgroup>
          {columnWidths.map(({ key, width }) => (
            <col key={key} style={{ width }} />
          ))}
        </colgroup>
      );
    }

    return null;
  };

  return (
    <div className="ds-simple-table-container">
      <TableContainer>
        <Table>
          {renderWidths()}
          <TableHead>
            {secondaryColumns && (
              <TableRow>
                {secondaryColumns.map(column => {
                  const headStyle = merge(column?.headStyle || {});

                  return (
                    <TableCell
                      key={column.key}
                      className={column.headClassName}
                      align={column.headAlign}
                      style={headStyle}
                    >
                      {column.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            )}
            <TableRow>
              {columns.map(column => {
                const headStyle = merge(column?.headStyle || {});

                return (
                  <TableCell
                    key={column.key}
                    className={column.headClassName}
                    align={column.headAlign}
                    style={headStyle}
                  >
                    {column.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.key || row.id}>
                {columns.map(column => (
                  <TableCell
                    key={column.key}
                    align={column.align}
                    className={column.className}
                    style={{ width: column.width || null }}
                  >
                    {column.render
                      ? column.render(row, row[column.key], column.key)
                      : row[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

SimpleTable.propTypes = {
  columns: PropTypes.array.isRequired,
  secondaryColumns: PropTypes.array,
  rows: PropTypes.array.isRequired,
  columnWidths: PropTypes.array
};

export default SimpleTable;
